import React from 'react';
import { updateObject, updateObjectProperty, updateSection } from './storeFunctions';
import { SECTIONS } from './reportStore';

const REORDER_SECTIONS = "REORDER_SECTIONS";
const SECTION_FOCUS_CHANGED = "SECTION_FOCUS_CHANGED";
const RECEIVE_REPORT = "RECEIVE_REPORT";
const SET_REPORT_SECTION_MENU_EDIT_MODE = 'SET_REPORT_SECTION_MENU_EDIT_MODE';
const ENTERING_REPORT = 'ENTERING_REPORT';
const ATTACH_SECTION = "ATTACH_SECTION";
const SECTION_IN_PDF = "SECTION_IN_PDF";

const TOGGLE_SHOW = "TOGGLE_SHOW";
const SHOW_HIDE_ALL_REPORT_SECTIONS = 'SHOW_HIDE_ALL_REPORT_SECTIONS';

const CREATE_NAV_CONFIG_SNAPSHOT = 'CREATE_NAV_CONFIG_SNAPSHOT';
const RESTORE_NAV_CONFIG_FROM_SNAPSHOT = 'RESTORE_NAV_CONFIG_FROM_SNAPSHOT';

const initialState = {
    focusedSectionId: '',
    sectionMap:[],
    elements: {},
    isSectionsMenuInEditMode: false
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case RECEIVE_REPORT:
            return updateObject(state, {sectionMap: action.data.map(x => {return {id:x.id, name:x.name, orderId:x.orderId, hidden:x.hidden, inPdf:x.inPdf, historyInPdf:x.historyInPdf, hasHistory:x.hasHistory, countryFilter: x.countryFilter}})});
        case SECTION_FOCUS_CHANGED:
            return updateObject(state, {focusedSectionId: action.sectionId});
        case SET_REPORT_SECTION_MENU_EDIT_MODE:
            return updateObject(state, { isSectionsMenuInEditMode: action.isEditMode });
        case ATTACH_SECTION:
            return updateObject(state, { elements: updateObjectProperty(state.elements, action.sectionId, action.element) });
        case ENTERING_REPORT:
            return updateObject(state, { focusedSectionId:action.focusedSectionId });
        case REORDER_SECTIONS:
            return updateObject(state, { sectionMap: action.navSections });
        case TOGGLE_SHOW:
            return updateObject(state, { sectionMap: updateSection(state.sectionMap, action.sectionId.slice(0), { hidden: action.newHidden }) });
        case SECTION_IN_PDF:
            return updateObject(state, { sectionMap: updateSection(state.sectionMap, action.sectionId.slice(0), { inPdf: action.inPdf, historyInPdf: action.historyInPdf }) });
        case SHOW_HIDE_ALL_REPORT_SECTIONS:
            return updateObject(state, { sectionMap: state.sectionMap.map(section => ({...section, hidden: section.id === SECTIONS.identData ? false : action.newHidden}))})
        case CREATE_NAV_CONFIG_SNAPSHOT:
            return updateObject(state, {
                sectionMap: action.sections.map(section =>
                    ({ ...section, hiddenSnapshot: section.hidden, orderIdSnapshot: section.orderId })
                )
            });
        case RESTORE_NAV_CONFIG_FROM_SNAPSHOT:
            return updateObject(state, {
                sectionMap: action.sections.slice(0)
                    .sort(
                        (a, b) => (a.orderIdSnapshot ? a.orderIdSnapshot : a.orderId) - (b.orderIdSnapshot ? b.orderIdSnapshot : b.orderId)
                    ).map(section => ({
                        ...section,
                        hidden: (section.hiddenSnapshot === null || section.hiddenSnapshot === undefined ? section.hidden : section.hiddenSnapshot),
                        orderId: (section.orderIdSnapshot ? section.orderIdSnapshot : section.orderId)
                    }))
            });
        default:
            return state;
    }
}

export const reportNavActions = {
    setFocusedSection: (id) => async (dispatch) => dispatch({type:SECTION_FOCUS_CHANGED, sectionId: id}),
    getVisibleSections: (myState) => (_, getState) => {
        const rep = myState || getState().reportNav;
        return ((rep || {}).sectionMap || []).filter(sec => !sec.hidden || rep.isSectionsMenuInEditMode);
    },
    createNavConfigSnapshot: () => (dispatch, getState) => dispatch({ type: CREATE_NAV_CONFIG_SNAPSHOT, sections: getState().reportNav.sectionMap.slice(0) }),
    restoreNavConfig: () => (dispatch, getState) => Array.isArray(getState().reportNav.sectionMap) && dispatch({ type: RESTORE_NAV_CONFIG_FROM_SNAPSHOT, sections: getState().reportNav.sectionMap.slice(0) }),
}